

















































































































import { Component, Prop, Mixins } from 'vue-property-decorator'
import {
  ICustomerLeadLightModel, PubPictureInfo, CustomerLeadFeedbackModel,
  $newObj, LeadFeedbackStatus
} from '@immosparrow/cockpit-api-v2'
import LeadDetails from './LeadDetails.vue'
import GlobalMixin from '@/mixins/GlobalMixin'
import LeadActions from './LeadActions.vue'
import moment from 'moment'

@Component({
  components: {
    LeadDetails,
    LeadActions
  }
})
export default class LeadItem extends Mixins(GlobalMixin) {
  @Prop()
  lead!: ICustomerLeadLightModel;

  get statusLiked () {
    return this.lead?.customerEvaluation?.evaluation === LeadFeedbackStatus.Like
  }

  get statusDisliked () {
    return this.lead?.customerEvaluation?.evaluation === LeadFeedbackStatus.Dislike
  }

  get statusViewed () {
    return this.lead?.customerViewedTime
  }

  get pictures () {
    return this.lead?.publication?.pictures?.map((item: PubPictureInfo) => {
      return this.generateImageUrl(item.id)
    }) || []
  }

  get fullScreenPictures () {
    return this.lead?.publication?.pictures?.map((item: PubPictureInfo) => {
      return this.generateImageUrl(item.id, window.innerWidth, window.innerHeight)
    })
  }

  get title (): string {
    return this.lead?.publication?.primaryInfo?.basicInfo?.title || ''
  }

  get address () {
    return this.displayAddress(this.lead?.publication?.address)
  }

  get currency () {
    return this.lead?.publication?.financialInfo?.currency?.text || 'CHF'
  }

  get price () {
    return this.formatPrice(this.lead?.publication?.financialInfo?.totalPriceCalculated)
  }

  get priceSqr () {
    return this.formatPrice(this.lead?.publication?.financialInfo?.pricePerSqrMeterCalculated)
  }

  get description () {
    const desc = this.lead?.publication?.primaryInfo?.basicInfo?.description || ''
    if (desc.length > 200) {
      return `${desc.substring(0, 190)}...`
    }
    return desc
  }

  get lang () {
    return this.$store.getters.language
  }

  get url () {
    return process.env.VUE_APP_URL
  }

  get wizardUrl () {
    if (this.lead.mailId && this.lead.publication?.id) {
      return `${process.env.VUE_APP_WIZARD_URL}?ispw-mailId=${this.lead.mailId}&ispw-publicationId=${this.lead.publication.id}`
    }
    return null
  }

  setSelectedLead () {
    if (this.lead.mailId) {
      this.$store.dispatch('getMailInfo', this.lead.mailId)
    } else {
      this.$store.commit('setMailInfo', null)
    }
    if (!this.lead.customerViewedTime) {
      this.lead.customerViewedTime = new Date()
      this.$store.dispatch('updateViewedStatus', this.lead.id)
    }
    this.$store.commit('setMultipleLeads', [])
    this.$store.commit('setLead', this.lead)
  }

  setGallery (ind: number) {
    this.$store.commit('setGallery', { index: ind, images: this.fullScreenPictures })
  }

  async updateLeadStatus (status: boolean) {
    const feedback = $newObj(CustomerLeadFeedbackModel)
    feedback.leadId = this.lead.id as string
    feedback.evaluation = status ? LeadFeedbackStatus.Like : LeadFeedbackStatus.Dislike
    await this.$store.dispatch('updateLeadStatus', feedback)
    this.$emit('updateLeadStatus', this.lead.id, status)
  }

  getDay (date: Date) {
    moment.locale(this.lang)
    return moment(date).format('dddd')
  }

  getDateAndTime (date: Date, format: string, lang?: string) {
    moment.locale(lang)
    return moment.utc(date.getTime()).local().format(format)
  }
}
